<script>
    import ContentSection from "../../../../common/ContentSection.svelte";
    import { _ } from "svelte-i18n";
    import { getEntity } from "../../../../api-client";
    import LoadingSquare from "../../../../common/LoadingSquare.svelte";

    export let audioInfo;
    export let podcastId;

    $: podcast = getEntity("podcast", podcastId);
</script>

<div>
    {#each audioInfo.sections ?? [] as section, index}
        <div class="text-section">
            <ContentSection title={section.header} paragraphPadding>
                <div slot="content">{@html section.content}</div>
            </ContentSection>
        </div>
        {#if index < audioInfo.sections.length - 1}
            <div class="divider-h" />
        {/if}
    {/each}

    <div class="divider-h" />

    {#await podcast}
        <LoadingSquare />
    {:then podcast}
        <div class="text-section">
            <ContentSection title={podcast.title} paragraphPadding>
                <div slot="content">
                    {#if podcast.description}
                        {@html podcast.description}
                    {/if}
                </div>
            </ContentSection>
        </div>
    {:catch}
        <div class="error">
            <span class="text-l" style="font-size: 24px;">
                {$_("entity_load_error")}
            </span>
        </div>
    {/await}

    <div class="divider-h" />

    <div class="details">
        <ContentSection title={$_("info_title")}>
            <div slot="content">
                <div class="details-info">
                    {#if audioInfo.duration}
                        <span class="headline-xs-custom details-title">
                            {$_("duration")}
                        </span>
                        <span class="details-content">{audioInfo.duration}</span
                        >
                    {/if}

                    {#if audioInfo.editors}
                        <span class="headline-xs-custom details-title">
                            {$_("editor")}
                        </span>
                        <span class="details-content">{audioInfo.editors}</span>
                    {/if}

                    {#if audioInfo.authors}
                        <span class="headline-xs-custom details-title">
                            {$_("moderation")}
                        </span>
                        <span class="details-content">{audioInfo.authors}</span>
                    {/if}

                    {#if audioInfo.production}
                        <span class="headline-xs-custom details-title">
                            {$_("production")}
                        </span>
                        <span class="details-content"
                            >{audioInfo.production}</span
                        >
                    {/if}
                </div>
            </div>
        </ContentSection>
    </div>
    <div class="text-m copyright">© Fondation Beyeler 2022</div>
</div>

<style>
    .details {
        padding: 32px 0;
    }

    .details-info {
        margin: 0px 0;
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        grid-row-gap: 16px;
        grid-column-gap: 16px;
    }

    .details-title {
        text-transform: none;
    }

    .copyright {
        margin-top: 16px;
        color: var(--black-40);
    }

    .text-section {
        padding: 16px 0;
    }

    .headline-xs-custom {
        font-family: "Trade Gothic LT Std";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 112%;
        /* or 20px */

        letter-spacing: -0.02em;
    }

    @media only screen and (min-width: 1440px) {
        .text-section {
            padding: 32px 32px 16px 0;
        }
    }
</style>
